import { render } from "./PricePopup.vue?vue&type=template&id=67a5bfef&scoped=true"
import script from "./PricePopup.vue?vue&type=script&lang=js"
export * from "./PricePopup.vue?vue&type=script&lang=js"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css"
import "./PricePopup.vue?vue&type=style&index=1&id=67a5bfef&lang=scss&scoped=true"
import "./PricePopup.vue?vue&type=style&index=2&id=67a5bfef&lang=scss"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5bfef"]])

export default __exports__